import React, { Component } from "react";

const RightArrowNew = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1L12 12L1 23" stroke={fill} />
    </svg>
  );
};

RightArrowNew.defaultProps = {
  width: 13,
  height: 24,
  fill: "black",
};

export default RightArrowNew;
